import React from 'react';
import DoctorsCard from "./DoctorsCard";
import DoctorHours from "./DoctorHours";
import DoctorCustomHours from "./DoctorCustomHours";

const ManageDoctor = ({doctor,onBack}) => {
    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                <div>
                    <h6 className="mb-0">
                        Doctor
                    </h6>
                    <p className="text-muted mb-0">Manage your doctor web booking profile.</p>
                </div>
                <div className="btn-group">

                    <button className="btn btn-outline-secondary" onClick={onBack}>
                        <i className="bi bi-arrow-left me-2"></i> Back
                    </button>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <DoctorsCard doctor={doctor}/>
                </div>

            </div>
            <div className="row mt-3">
                <div className="col-md-12">
                    <DoctorHours doctor={doctor} />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-md-12">
                    <DoctorCustomHours doctor={doctor} />
                </div>
            </div>
        </>
    );
};

export default ManageDoctor;